<template>
  <div class="service-detail-container">
    <div class="columns is-multiline" v-if="service">
      <!-- 서비스 정보 -->
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="서비스 정보">
            <div class="columns is-multiline">
              <div class="column is-half">
                <admin-form-item label="서비스 구분">
                  {{ serviceTypeKor[service.service_type] }}
                </admin-form-item>
                <admin-form-item label="서비스명(서비스 키)">
                  {{ service.service_name }} <span v-if="service.service_type !== 6">({{ service.key }})</span>
                </admin-form-item>

                <admin-form-item label="서비스 경로">
                  <div style="margin-top:4px">서비스<br>
                    <a :href="service.domain" target="_blank">{{ service.domain }}</a>
                  </div>
                  <div style="margin-top:8px">관리자<br>
                    <template v-if="service.service_type === 6">
                      <a :href="`${service.domain}/admin`" target="_blank">{{ service.domain + '/admin' }}</a>
                    </template>
                    <a v-else
                      :href="`${service.domain}/office/admin`" target="_blank">{{ service.domain + '/office/admin' }}</a>
                  </div>
                </admin-form-item>
                <admin-form-item label="사용자 정보">
                  <div><a :href="`/office/admin/user/create?id=${service.service_user.id}`" target="_blank">{{ service.service_user.name }}</a></div>
                  <div>{{ service.service_user.phone }}</div>
                  <div>{{ service.service_user.email }}</div>
                  <button-service-user :service="service"></button-service-user>
                </admin-form-item>
                <admin-form-item label="메일 수신자 정보">
                  <template v-if="service.receiver">
                    <div><a :href="`/office/admin/user/create?id=${service.receiver.id}`" target="_blank">{{ service.receiver.name }}</a></div>
                    <div>{{ service.receiver.phone }}</div>
                    <div>{{ service.receiver.email }}</div>
                  </template>
                  <div class="size-13" v-else>지정된 수신자 없음</div>
                  <button-service-user :service.sync="service" isReceiver></button-service-user>
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="서비스 상태">
                  <div>{{ status[service.status] }}</div>
                  <button-service-status :service="service"></button-service-status>
                </admin-form-item>
                <admin-form-item label="앱포팅" desc="진행중일 때 체크박스에 체크만 하고 저장해주세요.">
                  <lp-check-bool :checked-val.sync="service.android_status" label="안드로이드"></lp-check-bool>
                  <input type="text" class="input-border" v-model="service.android_package_name"
                         style="margin:4px 0 8px 0"
                         placeholder="안드로이드 패키지명(comp.package.name)">
                  <lp-check-bool :checked-val.sync="service.ios_status" label="IOS"></lp-check-bool>
                  <input type="text" class="input-border" v-model="service.ios_package_name"
                         style="margin-top:4px"
                         placeholder="IOS 패키지명(comp.package.name)">
                  <div class="flex-end" style="margin-top:8px">
                    <button class="button is-primary" style="width:90px" @click="saveApp">앱포팅 저장</button>
                  </div>
                </admin-form-item>

              </div>
            </div>
          </admin-box-item>
        </div>
        <!-- 서비스 스케쥴 관리 -->
        <div class="box">
          <admin-box-item title="결제 기간 관리">
            <div class="flex-end" style="margin-bottom:12px">
              <button class="button is-primary" style="width:100px" @click="clickAdd">+ 기간 추가</button>
            </div>
            <table>
              <tr>
                <th v-for="(item,idx) in header" :Key="`th-${idx}`" :style="`width:${item[1]}%`">{{ item[0] }}</th>
              </tr>
              <tr v-for="(item,idx) in schedule" :key="`schedule-tr-${idx}`" :class="{'prev': !item.current}"
                  @click="clickItem(item,idx)">
                <td>{{ idx+1 }}</td>
                <td>{{ item.type }}</td>
                <td>{{ datesFormat(item.start_date, 'date_3') }}</td>
                <td>{{ datesFormat(item.end_date, 'date_3') }}</td>
                <td>{{ datesFormat(item.next_date, 'date_3') }}</td>
                <td>
                  <div v-for="(prod,pidx) in item.products" :key="`prod-${pidx}`"
                      style="text-align: left">[{{ prod.category_name }}] {{ prod.name }}</div>
                </td>
                <td>{{ item.price|currency }}</td>
                <td>{{ item.pay_method_kor }}</td>
                <td>{{ item.date_unit }}개월</td>
              </tr>
            </table>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-4" v-if="service.talk && service.talk > 0">
        <div class="box">
          <launch-talk :talkId="service.talk" :isMemo="true"></launch-talk>
        </div>
      </div>
    </div>
    <modal-service-schedule :item="selectedItem" ref="ssModal"
                            @add="onAdd"
                            @update="onUpdate"
                            @delete="onDelete"></modal-service-schedule>
  </div>
</template>

<script>
  import moment from 'moment';
  import LaunchTalk from "../../../module/common/LaunchTalk";
  import ButtonServiceUser from "./components/ButtonServiceUser";
  import ButtonServiceStatus from "./components/ButtonServiceStatus";
  import ModalServiceSchedule from "./components/ModalServiceSchedule";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  export default {
    name: "ServiceDetail",
    components: {LpCheckBool, ModalServiceSchedule, ButtonServiceStatus, ButtonServiceUser, LaunchTalk},
    created() {
      this.getData();
    },
    methods: {
      onAdd(item) {
        this.schedule.splice(0,0, item);
      },
      onUpdate(item) {
        this.schedule[this.selectedIndex] = item;
        this.$forceUpdate();
      },
      onDelete() {
        removeIndex(this.schedule, this.selectedIndex);
      },
      clickItem(item,idx) {
        this.selectedItem = item;
        this.selectedIndex = idx;
        setTimeout(()=>{
          this.$refs.ssModal.open();
        })
      },
      clickAdd() {
        this.selectedItem = undefined;
        this.selectedIndex = -1;
        setTimeout(()=>{
          this.$refs.ssModal.open();
        })
      },
      saveApp() {
        let param = {
          android_status: this.service.android_status,
          ios_status: this.service.ios_status,
          android_package_name: this.service.android_package_name,
          ios_package_name: this.service.ios_package_name
        };
        this.$axios.patch(this.getUrl(`launchpack/service/${this.service.id}`), param).then(res => {
          if(res.status === 200) {
            this.toast('앱포팅 상태가 저장되었습니다.');
          }
        });
      },
      async getData() {
        // 서비스 상세
        let res_service = await this.$axios.get(this.getUrl(`launchpack/service/${this.$route.query.id}`));
        res_service.data.status_kor = this.status[res_service.data.status];
        this.service = res_service.data;

        let res = await this.$axios.get(this.getUrl(`launchpack/service/${this.$route.query.id}/schedule?status=2`));
        this.schedule = res.data.map(i => {
          if(i.main) {
            i.type = '메인';
          } else {
            i.type = {
              'package': '플랫폼 팩',
              'plugin': '플러그인',
              'service': '추가 서비스'
            }[i.app_type];
          }
          return i;
        });
      },
    },
    data() {
      return {
        service: undefined,
        schedule: [],
        selectedItem: undefined,
        selectedIndex: -1,
        serviceTypeKor: {
          0: '퀵빌더',
          1: '디자인마켓',
          2: '주문제작',
          3: '솔루션API',
          4: '플랫폼파이',
          5: '스킨',
          6: '독립형'
        },
        status: {
          0: '이용예정',
          1: '결제완료',
          5: '개설 진행 중',
          6: '디자인 수정 중',
          9: '서비스 중',
          10: '관리자 정지',
          99: '전체 정지',
          100: '이용중단',
          101: '삭제됨'
        },
        header: [
          ['index', 4],
          ['구분', 10],
          ['시작일', 10],
          ['종료일', 10],
          ['다음 결제예정일', 10],
          ['상품', 23],
          ['결제금액', 8],
          ['결제수단', 14],
          ['결제주기', 6]
        ]
      }
    }

  }
</script>

<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .service-detail-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
      tr:hover
        cursor pointer
        background-color $border-sub
    .prev
      background-color #fafafa
      color #777
  .button
    width 50px

</style>
<style lang="stylus">
  .lp-date-picker
    margin-bottom 0 !important
  .mx-datepicker
    width 130px
</style>
